import React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { getSecondaryColor } from 'lib/context/theme/utils';

const Header = styled.div`
  justify-content: space-between;
  display: flex;
  margin-bottom: 12px;
`;
const Title = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black[100]};
`;
const Manage = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.primary[100]}; /** SUS-961 changes **/
  text-decoration-line: underline;
  cursor: pointer;
`;
const Main = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => getSecondaryColor(theme)};
`;
type Props = {
  totalActiveUsers: any;
  totalAllowedUsers: any;
};
export const UsersOverview = ({
  totalActiveUsers,
  totalAllowedUsers,
}: Props) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      <Header>
        <Title>{t('Users')}</Title>
        <Manage onClick={() => history.push('/users/list')}>
          {t('Manage')}
        </Manage>
      </Header>
      <Main>
        {t('{{active}}/{{total}} active', {
          active: totalActiveUsers,
          total: totalAllowedUsers,
        })}
      </Main>
    </>
  );
};
